import React from 'react';

import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, RadioGroup, Radio, TextField, Typography, Grid, Button } from '@mui/material';
import { Save } from "@mui/icons-material"
import { validate } from "email-validator"

export default function Betrokkene(props) {

    const betrokkene = props.betrokkene;
    const updateBetrokkene = props.updateBetrokkene;

    return (
        <Box padding="20px">
            <Typography variant="body1">Basisgegevens Ondernemer en Bedrijf</Typography>
            <br /><br />
            <FormGroup>
                <FormControl>
                    <TextField type="kenmerk" variant="outlined" label="Kenmerk" value={betrokkene.kenmerk} name="kenmerk" onChange={(event) => updateBetrokkene(event.target.name, event.target.value)} /><br />
                    <TextField type="email" variant="outlined" label="Email" error={!validate(betrokkene.email)} value={betrokkene.email} name="email" onChange={(event) => updateBetrokkene(event.target.name, event.target.value)} /><br />
                    <TextField type="text" variant="outlined" label="Naam" value={betrokkene.naam} name="naam" onChange={(event) => updateBetrokkene(event.target.name, event.target.value)} /><br />
                    <TextField type="text" variant="outlined" label="Naam Onderneming" value={betrokkene.naamOnderneming} name="naamOnderneming" onChange={(event) => updateBetrokkene(event.target.name, event.target.value)} /><br />
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <TextField type="date" variant="outlined" label="Geboortedatum" value={betrokkene.geboorteDatum} name="geboorteDatum" onChange={(event) => updateBetrokkene(event.target.name, event.target.value)} InputLabelProps={{ shrink: true }} />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField type="date" variant="outlined" label="Ongevaldatum" value={betrokkene.ongevalDatum} name="ongevalDatum" onChange={(event) => updateBetrokkene(event.target.name, event.target.value)} InputLabelProps={{ shrink: true }} />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField type="date" variant="outlined" label="Saldibalans t/m period" value={betrokkene.saldibalans} name="saldibalans" onChange={(event) => updateBetrokkene(event.target.name, event.target.value)} InputLabelProps={{ shrink: true }} />
                        </Grid>
                    </Grid><br />
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <Box sx={{ border: "2px solid black", padding: "5px" }}>
                                <Typography>Rechtvorm</Typography>
                                <RadioGroup name="rechtvorm" value={betrokkene.rechtvorm} onChange={(event) => updateBetrokkene(event.target.name, event.target.value)}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={2}>
                                            <FormControlLabel value="EMZ" control={<Radio />} label="EMZ" />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <FormControlLabel value="VOF" control={<Radio />} label="VOF" disabled />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControlLabel value="Maatschap" control={<Radio />} label="Maatschap" disabled />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <FormControlLabel value="CV" control={<Radio />} label="CV" disabled />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <FormControlLabel value="BV" control={<Radio />} label="BV" disabled />
                                        </Grid>
                                    </Grid>
                                </RadioGroup>
                            </Box><br />
                        </Grid>
                        <Grid item xs={4}>
                            <Box sx={{ border: "2px solid black", padding: "5px" }}>
                                <Typography>Aangifte Aanwezig?</Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={betrokkene.aangifteJaarMinus1} name="aangifteJaarMinus1" onChange={(event) => { updateBetrokkene(event.target.name, event.target.checked) }} />
                                            }
                                            label={betrokkene.jaarMinus1}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={betrokkene.aangifteJaarMinus2} name="aangifteJaarMinus2" onChange={(event) => { updateBetrokkene(event.target.name, event.target.checked) }} />
                                            }
                                            label={betrokkene.jaarMinus2}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={betrokkene.aangifteJaarMinus3} name="aangifteJaarMinus3" onChange={(event) => { updateBetrokkene(event.target.name, event.target.checked) }} />
                                            }
                                            label={betrokkene.jaarMinus3}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid><br />
                    <Grid container spacing={2} columns={3}>
                        <Grid item xs={3}>
                            <Button variant="contained" startIcon={<Save />} style={{ flexShrink: true }} />
                        </Grid>
                    </Grid>
                </FormControl>
            </FormGroup>
        </Box>
    )
}